/* eslint-disable @typescript-eslint/no-explicit-any */
import Modal from "../../Components/Modal";
import { Vocabulary } from "../../Utils/Vocabulary";
import { TextField, CircularProgress, Button } from "@mui/material";
import { useEffect, useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import { UrlEnum } from "../../Utils/Utils";
import { postData } from "../../Services/postData";
import { toast } from "react-toastify";
import { updateData } from "../../Services/updateData";
import theme from "../../Theme/Theme";
import { DropzoneArea } from "material-ui-dropzone";
type CategoryProps = {
  open: boolean;
  onClose: (shouldRefetch?: boolean) => void;
  data: any;
};

export type CategoryState = {
  _id: string | null;
  name: string;
  file: string | null;
};

export default function Category({ open, onClose, data }: CategoryProps) {
  const [state, setState] = useState<CategoryState>({
    _id: null,
    name: "",
    file: null,
  });
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<any>(null);
  const notifySuccess = (message: string) => toast.success(message);
  const notifyError = (message: string) => toast.error(message);

  useEffect(() => {
    if (data) {
      setState(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * save template
   */
  function saveCategory() {
    setLoading(true);
    let url = UrlEnum.categories;
    const formData = new FormData();
    formData.append("name", state.name);
    if (file) formData.append("file", file, file.name);
    if (state._id) {
      url = `${url}/${state._id}`;
      updateData(url, formData)
        .then((res) => {
          onClose(true);
          notifySuccess(Vocabulary.saveSuccess);
          setLoading(false);
        })
        .catch((err) => {
          notifyError(Vocabulary.saveError);
          setLoading(false);
        });
    } else {
      postData(url, formData)
        .then((res) => {
          onClose(true);
          notifySuccess(Vocabulary.saveSuccess);
          setLoading(false);
        })
        .catch((err) => {
          notifyError(Vocabulary.saveError);
          setLoading(false);
        });
    }
  }

  /**
   *
   * @param files
   */
  function handleChangeDropFile(files: any) {
    if (files.length !== 0) {
      if (files[0].type.match("image.*")) {
        setFile(files[0]);
      }
    }
  }

  return (
    <>
      <Modal
        title={Vocabulary.newCategory}
        open={open}
        onClose={() => onClose(false)}
        restModalProps={{
          maxWidth: "xl",
        }}
      >
        <br />
        <TextField
          fullWidth
          size="small"
          label={Vocabulary.templateName}
          value={state.name}
          onChange={(event: any) =>
            setState({ ...state, name: event.target.value })
          }
        />
        {state.file ? (
          <div style={{ textAlign: "center" }}>
            <img
              style={{ height: 150, margin: "20px auto 10px auto" }}
              src={state.file}
              alt="No file"
            />
          </div>
        ) : (
          ""
        )}
        <div style={{ marginTop: 10 }}>
          <DropzoneArea
            acceptedFiles={["image/*"]}
            maxFileSize={1000000}
            filesLimit={1}
            onChange={handleChangeDropFile}
            dropzoneClass="custom-dropzone"
          />
        </div>
        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Button
            variant="contained"
            size="large"
            style={{
              color: theme.palette.whiteColor?.main,
              backgroundColor: theme.palette.primary?.main,
            }}
            color="primary"
            onClick={saveCategory}
          >
            <SaveIcon /> &nbsp;&nbsp;{Vocabulary.save}
          </Button>
        </div>
      </Modal>

      {loading ? (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
